module.exports = __webpack_public_path__ + "img/heven-logo.ef2690a4.png";